"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertiesStatsEstimatedValues$ = exports.PropertiesStatsEstimatedValues$outboundSchema = exports.PropertiesStatsEstimatedValues$inboundSchema = void 0;
exports.propertiesStatsEstimatedValuesToJSON = propertiesStatsEstimatedValuesToJSON;
exports.propertiesStatsEstimatedValuesFromJSON = propertiesStatsEstimatedValuesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
/** @internal */
exports.PropertiesStatsEstimatedValues$inboundSchema = z.object({
    estimate_date: z.string().transform(v => new rfcdate_js_1.RFCDate(v)),
    estimated_market_value: z.number().int(),
    estimated_market_value_rounded: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "estimate_date": "estimateDate",
        "estimated_market_value": "estimatedMarketValue",
        "estimated_market_value_rounded": "estimatedMarketValueRounded",
    });
});
/** @internal */
exports.PropertiesStatsEstimatedValues$outboundSchema = z.object({
    estimateDate: z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString()),
    estimatedMarketValue: z.number().int(),
    estimatedMarketValueRounded: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        estimateDate: "estimate_date",
        estimatedMarketValue: "estimated_market_value",
        estimatedMarketValueRounded: "estimated_market_value_rounded",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertiesStatsEstimatedValues$;
(function (PropertiesStatsEstimatedValues$) {
    /** @deprecated use `PropertiesStatsEstimatedValues$inboundSchema` instead. */
    PropertiesStatsEstimatedValues$.inboundSchema = exports.PropertiesStatsEstimatedValues$inboundSchema;
    /** @deprecated use `PropertiesStatsEstimatedValues$outboundSchema` instead. */
    PropertiesStatsEstimatedValues$.outboundSchema = exports.PropertiesStatsEstimatedValues$outboundSchema;
})(PropertiesStatsEstimatedValues$ || (exports.PropertiesStatsEstimatedValues$ = PropertiesStatsEstimatedValues$ = {}));
function propertiesStatsEstimatedValuesToJSON(propertiesStatsEstimatedValues) {
    return JSON.stringify(exports.PropertiesStatsEstimatedValues$outboundSchema.parse(propertiesStatsEstimatedValues));
}
function propertiesStatsEstimatedValuesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertiesStatsEstimatedValues$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertiesStatsEstimatedValues' from JSON`);
}
//# sourceMappingURL=propertiesstatsestimatedvalues.js.map